export enum ScrollZone {
  full = 'full',
  scrollbar = 'scrollbar'
}

export type ScrollController = {
  scrollTo: (left: number) => void;
  scrollBy: (delta: number) => void;
};
